<template>
    <div class="addBox relative">
        <div class="title">
            <div class="title_left"><span class="movePoin" @click="$router.go(-1)">人员管理</span>/<span class="type">{{type=='add'?'新增':'编辑'}}</span></div>
        </div>
        <el-form :model="form" :rules="rules" ref="form" label-width="150px">
			<ToggleForm title="基本信息">
				<div class="content">
					<div class="row mt20">
						<el-form-item label="姓名：" prop="realName">
							<el-input placeholder="请输入姓名" class="w300" maxlength="15" v-model="form.realName"></el-input>
						</el-form-item>
					</div>
					<div class="row">
						<el-form-item label="性别：" prop="gender">
                            <el-select class="w300" v-model="form.gender" placeholder="请选择性别">
                                <el-option class="w300" v-for="item in genderList" :key="item.code" :label="item.name" :value="item.code">
                                </el-option>
                            </el-select>
						</el-form-item>
					</div>
					<div class="row">
						<el-form-item label="身份证：" prop="idCard">
							<el-input placeholder="请输入身份证号"  class="w300" v-model="form.idCard"></el-input>
						</el-form-item>
					</div>
					<div class="row">
						<el-form-item label="手机(账号)：" prop="mobile">
							<el-input placeholder="请输入手机号"  maxlength="11" class="w300" v-model="form.mobile"></el-input>
						</el-form-item>
					</div>
                    <div class="row">
						<el-form-item label="工作岗位：" prop="post">
							<el-input placeholder="请输入工作岗位"  maxlength="15" class="w300" v-model="form.post"></el-input>
						</el-form-item>
					</div>
				</div>
			</ToggleForm>
            <ToggleForm title="业务权限">
				<div class="content">
					<div class="row mt20" v-if="type!='add'">
						<el-form-item label=" 启用禁用：" prop="avaliable">
							<el-switch v-model="form.avaliable" active-color="#70CE97" inactive-color="#cccccc">
							</el-switch> {{form.avaliable?'启用':'禁用'}}
						</el-form-item>
					</div>
					<div class="row ":class="{'mt20':type=='add'}">
						<el-form-item label="业务权限(可多选)：" prop="roleList" class="clear_a" >
              <el-checkbox-group v-model="list" size="large" @change="change">
                <el-checkbox-button v-for="(item,index) in roleListArr" :label="item.key" :key="item.key">{{item.label}}</el-checkbox-button>
              </el-checkbox-group>
						</el-form-item>
					</div>
					<div class="row">
						<el-form-item label="人员类别(可多选)：" prop="employeeCategory" class="clear_a" >
              <el-checkbox-group v-model="form.employeeCategory" size="large">
                  <el-checkbox-button v-for="(item,index) in employee" :label="item.key" :key="item.key">{{item.label}}</el-checkbox-button>
              </el-checkbox-group>
						</el-form-item>
					</div>
				</div>
			</ToggleForm>
            <ToggleForm title="附件上传">
				<div class="content">
                    <div class="row mt20">
						<el-form-item label="截止有效期：" prop="healthCertificateValidityPeriod" class="clear_a">
                            <el-date-picker class="w300" :picker-options="pickerOptions" v-model="form.healthCertificateValidityPeriod" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :editable="false" :clearable="true" placeholder="选择日期">
                            </el-date-picker>
						</el-form-item>
					</div>
                    <div class="row rowybUpload">
                        <el-form-item label="健康证图片：">
                            <p class="rowybUploadText w400">上传图片大小不超过10M；上传格式：jpg、png、gif，只能上传1张图片。</p>
                            <ybUpload :maxLength=1 @uploadSuccess='getFiles' @uploadError="getFiles"
                                @remove='getFiles' :filesArr='filesArr'></ybUpload>
                                <!-- filesArr:[],回显的时候必传 -->
                        </el-form-item>
                    </div>
					 <div class="row rowybUpload">
                        <el-form-item label="身份证图片：">
                            <p class="rowybUploadText w400">上传图片大小不超过10M；上传格式：jpg、png、gif，只能上传1张图片。</p>
                            <ybUpload :maxLength=1 @uploadSuccess='getFiles1' @uploadError="getFiles1"
                                @remove='getFiles1' :filesArr='filesArr1'></ybUpload>
                                <!-- filesArr:[],回显的时候必传 -->
                        </el-form-item>
                    </div>
				</div>
			</ToggleForm>
		</el-form>
		<div class="foot-btn">
			<div>
			<el-button class="w70 mr10" @click="$router.go(-1)">取消</el-button>
			<el-button type="primary w70" :disabled="btn"  @click="submit(type)">保存</el-button>
			</div>
		</div>
    </div>
</template>

<script>
import ToggleForm from "components/ToggleForm";
import ybUpload from "components/ybUpload";
import { getMapping } from "@/utils/mapping";
import * as api from "api/personApi";
const validate = {};
validate.realName = (rule, value, callback) => {
  let text = value.trim();
  if (text == "" || text.length > 15) {
    callback(new Error("姓名必填，并且必须是1-15字以内"));
  } else {
    callback();
  }
};
validate.mobile = (rule, value, callback) => {
  let text = value.trim();
  let zc = /^[1]([3-9])[0-9]{9}$/;
  if (text == "" || !zc.test(text)) {
    callback(new Error("必须是正确的手机号码"));
  } else {
    callback();
  }
};
validate.post = (rule, value, callback) => {
  let text = value.trim();
  if (text == "" || text.length > 15) {
    callback(new Error("工作岗位必填，并且必须是1-15字以内"));
  } else {
    callback();
  }
};
export default {
  name: "personadd",
  components: { ToggleForm, ybUpload },
  data() {
    return {
      list:[],
      id: "",
      baseUrl: this.$store.state.common.baseUrl,
      btn: false,
      type: "add",
      genderList: [],
      employee: [],
      filesArr1: [],
      filesArr: [],
      rules: {
        realName: [
          {
            required: true,
            validator: validate.realName,
            trigger: "blur"
          }
        ],
        mobile: [
          {
            required: true,
            validator: validate.mobile,
            trigger: "blur"
          }
        ],
        post: [
          {
            required: true,
            validator: validate.post,
            trigger: "blur"
          }
        ]
      },
      roleListArr: [
        { key: "01", label: "晨检公示" },
        { key: "02", label: "清洗消毒" },
        { key: "03", label: "食品留样" },
        { key: "04", label: "餐厨垃圾" },
        { key: "05", label: "食堂陪餐" },
        { key: "06", label: "教育培训" },
        //  {key:'07',label:'自检自查'},
        { key: "08", label: "每日菜谱" },
        { key: "16", label: "添加剂记录" },
        { key: "14", label: "进货查验" },
        { key: "1401", label: "进货查验-管理" },
        { key: "15", label: "出库登记" },
        { key: "1501", label: "出库登记-管理" }
      ],
      form: {
        realName: "",
        mobile: "",
        roleList: [],
        id: "",
        post: "",
        avaliable: 1,
        healthCertificateFileId: "", //健康证附件id
        idCardFileId: "", //身份证附件id
        healthCertificateValidityPeriod: "", //健康证有效期(yyyy-MM-dd)
        gender: "",
        idCard: "",
        employeeCategory: [] //职员类别
      },
      pickerOptions: {
        disabledDate: time => {
          return time.getTime() < Date.now() - 8.64e7;
        }
      }
    };
  },
  methods: {
    change(val){
      // console.log(val)
      console.log(this.form.roleList)
    },
    initData() {
      let employee = getMapping().employee;
      for (let i in employee) {
        let obj = {
          key: i ,
          // + "1",
          label: employee[i]
        };
        this.employee.push(obj);
      }
      this.genderList.push({
        code: "",
        name: "请选择性别"
      });
      let result = getMapping().gender;
      for (let i in result) {
        let obj = {
          code: i,
          name: result[i]
        };
        this.genderList.push(obj);
      }
    },
    getFiles(files, state) {
      this.form.healthCertificateFileId =
        files.length <= 0 ? "" : files[0].fileId;
    },
    getFiles1(files, state) {
      this.form.idCardFileId = files.length <= 0 ? "" : files[0].fileId;
    },
    validator() {
      if (
        this.form.healthCertificateFileId.length > 0 &&
        this.form.healthCertificateValidityPeriod == ""
      ) {
        this.$message.warning("请输入健康证有效期");
        return false;
      } else {
        return true;
      }
    },
    submit(type) {
      this.btn = true;
      this.$refs["form"].validate(valid => {
        if (valid && this.validator()) {
          let text = type == "add" ? "添加" : "编辑";
          this.$confirm("是否确认提交你的" + text + "？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(() => {
              this.form.avaliable = this.form.avaliable ? 1 : 0;
              this.form.employeeCategory=this.form.employeeCategory.join(",")
              this.form.roleList = this.list;
              api.personAdd(type, this.form).then(r => {
                if (r.code == 200) {
                  let showToast =
                    type == "add"
                      ? "人员添加成功，初始密码为111111"
                      : "操作成功！";
                  this.$message({
                    message: showToast,
                    type: "success"
                  });
                  setTimeout(() => {
                    if (type == "add") {
                      this.$router.go(-1);
                    } else {
                      this.$router.go(-2);
                    }
                  }, 1500);
                } else {
                  if (this.form.employeeCategory == "") {
                    this.form.employeeCategory = [];
                  } else {
                    this.form.employeeCategory = this.form.employeeCategory.split(
                      ","
                    );
                    // let arr = [];
                    // this.form.employeeCategory.forEach(item => {
                    //   arr.push(item + "1");
                    // });
                    // this.form.employeeCategory = arr;
                  }
                  // let arr1 = [];
                  // this.form.roleList.forEach(item => {
                  //   arr1.push(item + "x");
                  // });
                  // this.form.roleList = arr1;
                }
                this.btn = false;
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消" + text
              });
              this.btn = false;
            });
        } else {
          console.log("error submit!!");
          this.btn = false;
        }
      });
    },
    initEditData() {
      api.personInfo(this.id).then(r => {
        if (r.code == 200) {
          this.form = r.data;
          // 禁用
          this.form.avaliable = this.form.avaliable == 1 ? true : false;
          // 健康证图片
          if (
            this.form.healthCertificateFileDto !== null &&
            this.form.healthCertificateFileDto !== ""
          ) {
            this.filesArr.push({
              url:
                this.baseUrl + "/" + this.form.healthCertificateFileDto.fileUrl,
              fileId: this.form.healthCertificateFileDto.fileId
            });
            this.form.healthCertificateFileId=this.form.healthCertificateFileDto.fileId//健康证附件id
          }
          // 身份证图片
          if (
            this.form.idCardFileDto !== null &&
            this.form.idCardFileDto !== ""
          ) {
            this.filesArr1.push({
              url: this.baseUrl + "/" + this.form.idCardFileDto.fileUrl,
              fileId: this.form.idCardFileDto.fileId
            });
            this.form.idCardFileId= this.form.idCardFileDto.fileId //身份证附件id
          }
          // 职员类别
          if (
            this.form.employeeCategory == "" ||
            this.form.employeeCategory === null
          ) {
            this.form.employeeCategory = [];
          } else {
            this.form.employeeCategory = this.form.employeeCategory.split(",");
            // let arr = [];
            // this.form.employeeCategory.forEach(item => {
            //   arr.push(item + "1");
            // });
            // this.form.employeeCategory = arr;
          }
          this.list = this.form.roles;
          // 身份证
          this.form.idCard = this.form.idCard === null ? "" : this.form.idCard;
          if (
            this.form.healthCertificateValidityPeriod === null ||
            this.form.healthCertificateValidityPeriod == ""
          ) {
            this.form.healthCertificateValidityPeriod = "";
          }
        }
      });
    }
  },
  mounted() {
    this.initData();
    this.type = this.$route.query.type ? this.$route.query.type : "add";
    this.id = this.$route.query.id ? this.$route.query.id : "";
    if (this.type == "edit") {
      this.initEditData();
    }
  }
};
</script>

<style scoped lang='scss'>
.addBox {
  width: calc(100% - 40px);
  min-height: 100%;
  padding: 0 20px 100px 20px;
  .title {
    height: 60px;
    line-height: 60px;
    .title_left {
      font-size: 20px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      width: 50%;
      height: 100%;
      .type {
        color: #70ce97;
      }
    }
  }
}
</style>